export default "__VITE_ASSET__e7f0f6a0__"